export default __webpack_public_path__ + "static/media/Scribe's Staff.35936329.jpg";